var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"liquor-background"},[(_vm.map)?_c('div',{staticClass:"map"},[_c('WorldMap')],1):_vm._e(),_c('div',{staticClass:"slides"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"slide",class:{
      'prev': index === _vm.prevIndex,
      'curr': index === _vm.currIndex,
      'next': index === _vm.nextIndex
  }},[_c('div',{style:(("background-image: url(" + (_vm.list[index]) + ")"))})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }